"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { SegmentedControl } from "@boostdev/design-system-components/client";
import { useClientTranslation } from "@/lib/i18n/client";

interface MenuItem {
  title: string;
  path: string;
}

export function MainMenu() {
  const { t } = useClientTranslation();
  const pathname = usePathname();

  const menu: MenuItem[] = [
    { title: t("common:menu.home"), path: "/" },
    { title: t("common:menu.gallery"), path: "/gallery" },
    { title: t("common:menu.shop"), path: "/shop" },
    { title: t("common:menu.photoCode"), path: "/photo-code" },
  ];

  const unprefixed = pathname.replace(/^\/(en|nl)(?=\/|$)/, "") || "/";

  const isActive = (path: string) =>
    path === "/"
      ? unprefixed === "/"
      : unprefixed === path || unprefixed.startsWith(`${path}/`);

  return (
    <SegmentedControl size="small">
      {menu.map((item) => (
        <Link
          key={item.path}
          href={item.path}
          prefetch
          aria-current={isActive(item.path) ? "page" : undefined}
        >
          {item.title}
        </Link>
      ))}
    </SegmentedControl>
  );
}
